import React, { useState, useEffect } from "react";
import { Col, Row, Form } from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import Spinner from 'react-bootstrap/Spinner';
import { onError } from "../libs/errorLib";
import { API } from 'aws-amplify';
import Plot from 'react-plotly.js';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import Table from 'react-bootstrap/Table';
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { startCase } from 'lodash';
import { myListTimeSeriess } from '../graphql/my.queries';

// custom data fetching/processing hook
// https://www.robinwieruch.de/react-hooks-fetch-data
const useRestApi = (Symbol, Frequency, CsvFile, RiskDriver) => {
  const [symbol, setSymbol] = useState(Symbol);
  const [frequency, setFrequency] = useState(Frequency);
  const [csvFile, setCsvFile] = useState(CsvFile);
  const [riskDriver, setRiskDriver] = useState(RiskDriver);
  //const [nextStepModel, setNextStepModel] = useState(NextStepModel);
  const [isComputing, setIsComputing] = useState(false);
  const [isError, setIsError] = useState(false);
  const [dataCols, setDataCols] = useState({});
  const [dataRows, setDataRows] = useState({});

  const apiName = 'restapimeucci';
  const path = '/data-process/risk-driver'; //quest
  const myInit = { // OPTIONAL
    headers: {}, // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: { 
      symbol: symbol,
      csvFile: csvFile,
      riskDriver: riskDriver
      //nextStepModel: nextStepModel
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false);
      setIsComputing(true);
 
      try {
        const response = await API.get(apiName, path, myInit);
        //console.log(response.data);
        //console.log(JSON.parse(response.data.output));
        setDataRows(JSON.parse(response.data.output));
        
        // reformat response.data.output to columns
        var date_arr = [];
        var value_arr = [];
        var riskDriver_arr = [];
        //var invariant_arr = [];
      
        JSON.parse(response.data.output).forEach((item) => {
          date_arr.push(item.Date);
          value_arr.push(item.Value);
          riskDriver_arr.push(item.RiskDriver);
          //invariant_arr.push(item.Invariant);
        });

        //console.log(value_arr);
        //console.log(riskDriver_arr);
        setDataCols({'Date': date_arr, 'Value': value_arr, 'RiskDriver': riskDriver_arr});
      } catch (error) {
        setIsError(true);
        onError(error);
      }
 
      setIsComputing(false);
    };

    //console.log('Trying fetch : symbol=' + symbol + ' riskDriver=' + riskDriver);
    if (symbol !== "" && riskDriver !== "") {
      fetchData();
      //console.log('Fetch OK! ' + symbol + ' ' + riskDriver);
    }

  }, [symbol, riskDriver]);
 
  return [{ dataCols, dataRows, isComputing, isError }, setSymbol, setFrequency, setCsvFile, setRiskDriver];
};


export default function RiskDriver() {
  const [isLoading, setIsLoading] = useState(true);
  const [timeSeriess, setTimeSeriess] = useState(null);
  const [symbol, setSymbol] = useState(null);
  const [frequency, setFrequency] = useState(null);
  const [csvFile, setCsvFile] = useState(null);
  const [riskDriver, setRiskDriver] = useState("");
  const [timeSeriesSelected, setTimeSeriesSelected] = useState(false);
  const [riskDriverSelected, setRiskDriverSelected] = useState(false);

  const [{ dataCols, dataRows, isComputing, isError }, 
    setSymbolArg, setFrequencyArg, setCsvFileArg, setRiskDriverArg] = useRestApi(
      symbol, frequency, csvFile, riskDriver);

  useEffect(() => {
    // fetch async data within useEffect hook (not as separate function) otherwise big problems
    // https://blog.logrocket.com/usestate-vs-useref/
    const fetchData = async () => {
      try {
        const apiData = await API.graphql({ query: myListTimeSeriess });
        const tsFromApi = apiData.data.listTimeSeriess.items;
        await Promise.all(tsFromApi);
        setTimeSeriess(apiData.data.listTimeSeriess.items);
        //console.log('tsFromApi len = ' + tsFromApi.length);
        //for (const [key, value] of Object.entries(tsFromApi)) {
          //console.log(`${key}: ${value.symbol}|${value.frequency}|${value.csvFile}`);
        //} 
      } catch (error) {
        onError(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  function handleInputChange(event) {
    // used for disabling submit button
    switch (event.target.id) {
      case "selectTimeSeries":
        setTimeSeriesSelected(true);
        break;
      case "selectRiskDriver":
        //setRiskDriver(event.target.value);
        setRiskDriverSelected(true);
        break;
      default:
        console.log("No input change.");
        break;
    }
    //console.log("Input changed: " + event.target.id + " - " + event.target.value);
  }

  function validateForm() {
    // disables submit button if inputs not selected
    return (timeSeriesSelected) && (riskDriverSelected);
  }

  function handleSubmit(event) {
    let timeSeriesParams = document.getElementById('selectTimeSeries').value.split("|");
    setSymbol(timeSeriesParams[0]);
    setFrequency(timeSeriesParams[1]);
    setCsvFile(timeSeriesParams[2]);
    setSymbolArg(timeSeriesParams[0]);
    setFrequencyArg(timeSeriesParams[1]);
    setCsvFileArg(timeSeriesParams[2]);
    setRiskDriver(document.getElementById('selectRiskDriver').value);
    setRiskDriverArg(document.getElementById('selectRiskDriver').value)
    event.preventDefault();
  }

  function ControlledTabs(props) {
    return (
      
      <div style={{display: 'block', width: '100%'}}>
        <Tabs defaultActiveKey="chart">
          <Tab eventKey="chart" title="Chart">
            <br />
            <QuestCharts dataCols={props.dataCols}/>
          </Tab>
          <Tab eventKey="data" title="Data">
            <br />
            <DataTable dataRows={props.dataRows}/>
          </Tab>
          <Tab eventKey="desc" title="Description">
            <br />  
            <Table size="sm" className="table table-borderless">
              <tbody>
                <tr>
                  <td className="col-md-2"><strong>Symbol:</strong></td>
                  <td className="col-md-10">{props.symbol}</td>
                </tr>
                <tr>
                  <td className="col-md-2"><strong>Frequency:</strong></td>
                  <td className="col-md-10">{startCase(props.frequency)}</td>
                </tr>
                <tr>
                  <td className="col-md-2"><strong>Data File:</strong></td>
                  <td className="col-md-10">{props.csvFile}</td>
                </tr>
                <tr>
                  <td className="col-md-2"><strong>Risk Driver:</strong></td>
                  <td className="col-md-10">{startCase(props.riskDriver)}</td>
                </tr>
                <tr>
                  <td className="col-md-2"><strong>Summary:</strong></td>
                  <td className="col-md-10">
                    {/* Data has {props.dataCols.Date.length} rows and {Object.keys(props.dataCols).length} columns:<br /> */}
                    Data has {props.dataCols.Date.length} rows and 3 columns:<br />
                      <ul>
                        {/*                     {
                        Object.entries(props.dataCols).map(([key, value], index) => {
                          return(
                            <li key={index.toString()} value={key} data-type="text">{startCase(key)}</li>
                          )
                      })} */}
                        <li>Date</li>
                        <li>Value</li>
                        <li>Risk Driver</li>
                      </ul>                
                  </td>
                </tr>
              </tbody>
            </Table>
          </Tab>
        </Tabs>
      </div>
    );
  }
  
  function QuestCharts(props) {
    return (
      <>
      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.RiskDriver,
              type: 'line',
              mode: 'lines',
              marker: {color: 'green'},
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Risk Driver '} }
        /> 
      </div>
      <hr className="featurette-divider" />
      <div>
        <Plot
          data={[
            {
              x: props.dataCols.Date,
              y: props.dataCols.Value,
              type: 'line',
              mode: 'lines',
              marker: {color: 'black'},
            },
          ]}
          config={ {responsive: true} }
          layout={ {title: symbol + ' Value'} }
        /> 
      </div>
      </>
    );  
  }
  
  function DataTable(props) {
    // data must be in rows
    //console.log('test dt: ' + props.dataRows);
    const dataTableColumns = [
      {
        dataField: "Date",
        text: "Date",
        sort: true
      },
      {
        dataField: "Value",
        text: "Value",
      },
      {
        dataField: "RiskDriver",
        text: "Risk Driver"
      },
    ];
    return (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="Date"
          data={props.dataRows}
          columns={dataTableColumns}
          pagination={paginationFactory({ sizePerPage: 100 })}
          striped
          hover
          condensed
        />
      </div>
    );
  }


  return (
    <main className="flex-shrink-0">
      <div className="container">
        <h4 className="mt-3">Risk Driver Identification</h4>
        <br />
        <div className="container">
          <div className="row">
            {isError && <div>Error occurred [useRestApi function?] ...</div>}
            <div className="col-3">
              { isLoading ? (
                <Spinner animation="border" style={{color: "#990000"}}/>
                ) : (
                <>
                <div className="card">
                  <div className="card-body">
                    <Form onSubmit={handleSubmit}>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectTimeSeries">
                          <Form.Label>Time series:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="" key="0">Select time series...</option>
                            {
                              Object.entries(timeSeriess).map(([key, value], index) => {
                                return(
                                  <option key={key+1} value={value.symbol + '|' + value.frequency + '|' + value.csvFile} data-type="text">{value.symbol}_{value.frequency}</option>
                                )
                              })
                            }                                
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="selectRiskDriver">
                          <Form.Label>Risk Driver:</Form.Label>
                          <Form.Control as="select" onChange={handleInputChange}>
                            <option value="">Select risk driver...</option>
                            <option value="value">Value</option>
                            <option value="logValue">Log Value</option>
                          </Form.Control>
                        </Form.Group>
                      </Row>
                      <Row>
                        <Form.Group as={Col} size="lg" controlId="buttonSubmit">
                          <LoaderButton
                            size="md"
                            type="submit"
                            isLoading={isComputing}
                            disabled={!validateForm()}
                          >
                            Identify Risk Driver
                          </LoaderButton>
                        </Form.Group>
                      </Row>
                    </Form>
                  </div>
                </div>
                </>
                )
              }
            </div>
            <div className="col-9">
              { !isComputing && Object.keys(dataCols).length > 0 &&
                <ControlledTabs dataCols={dataCols} dataRows={dataRows} symbol={symbol} frequency={frequency} csvFile={csvFile} 
                  riskDriver={riskDriver}/>
              } 
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}